import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/workforce/dashboard` — dal 04-11-2026 le pagine di «Risorse umane» stanno tutte sotto `/hr/`. L'indirizzo vecchio
 * resta come rinvio, coi suoi parametri, per i preferiti, i collegamenti salvati e quelli negli avvisi.
 */
export const Route = createFileRoute('/_app/workforce/dashboard')({
  beforeLoad: ({ search }) => { throw redirect({ to: '/hr/dashboard', search: search as never, replace: true }); },
});
